import React from 'react';
import { FileTextIcon, LayersIcon, ShieldCheckIcon } from 'lucide-react';
export function InsideSection() {
  return <section className="w-full bg-bg-section py-16 md:py-24 px-4" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        <div className="text-center mb-12 md:mb-16" data-id="element-208">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-209">
            Cómo se ve por dentro
          </h2>
          <p className="text-base md:text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto" data-id="element-210">
            Un ebook estructurado, claro y directo que te guía paso a paso sin
            información innecesaria.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-211">
          <div className="text-center" data-id="element-212">
            <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-full mb-3 md:mb-4" data-id="element-213">
              <FileTextIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-214" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-215">
              Formato profesional
            </h3>
            <p className="text-sm md:text-base text-text-secondary" data-id="element-216">
              PDF estructurado con navegación clara, índice detallado y formato
              profesional.
            </p>
          </div>

          <div className="text-center" data-id="element-217">
            <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-full mb-3 md:mb-4" data-id="element-218">
              <LayersIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-219" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-220">
              Organización por pilares
            </h3>
            <p className="text-sm md:text-base text-text-secondary" data-id="element-221">
              Contenido organizado siguiendo los 4 pilares de la Infraestructura
              Única de Valor.
            </p>
          </div>

          <div className="text-center" data-id="element-222">
            <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-cta/10 rounded-full mb-3 md:mb-4" data-id="element-223">
              <ShieldCheckIcon className="w-6 h-6 md:w-8 md:h-8 text-cta" data-id="element-224" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-225">
              Instrucciones paso a paso
            </h3>
            <p className="text-sm md:text-base text-text-secondary" data-id="element-226">
              Cada proceso explicado con instrucciones claras, directas y
              aplicables inmediatamente.
            </p>
          </div>
        </div>

        <div className="bg-bg-card p-6 md:p-10 rounded-xl" data-id="element-227">
          <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6" data-id="element-228">
            Estructura del contenido
          </h3>
          <div className="space-y-3 md:space-y-4" data-id="element-229">
            <div className="flex items-start gap-3 md:gap-4 pb-3 md:pb-4 border-b border-text-secondary/10" data-id="element-230">
              <span className="text-cta font-bold text-base md:text-lg flex-shrink-0" data-id="element-231">
                01
              </span>
              <div data-id="element-232">
                <h4 className="font-semibold mb-1 text-sm md:text-base" data-id="element-233">
                  Introducción al sistema empresarial en EE.UU.
                </h4>
                <p className="text-text-secondary text-xs md:text-sm" data-id="element-234">
                  Fundamentos del sistema legal y empresarial estadounidense
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 md:gap-4 pb-3 md:pb-4 border-b border-text-secondary/10" data-id="element-235">
              <span className="text-cta font-bold text-base md:text-lg flex-shrink-0" data-id="element-236">
                02
              </span>
              <div data-id="element-237">
                <h4 className="font-semibold mb-1 text-sm md:text-base" data-id="element-238">
                  Pilar 1: Registrar — Autonomía Legal
                </h4>
                <p className="text-text-secondary text-xs md:text-sm" data-id="element-239">
                  Proceso completo de registro empresarial y creación de base
                  legal
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 md:gap-4 pb-3 md:pb-4 border-b border-text-secondary/10" data-id="element-240">
              <span className="text-cta font-bold text-base md:text-lg flex-shrink-0" data-id="element-241">
                03
              </span>
              <div data-id="element-242">
                <h4 className="font-semibold mb-1 text-sm md:text-base" data-id="element-243">
                  Pilar 2: Estructurar — Inteligencia Fiscal
                </h4>
                <p className="text-text-secondary text-xs md:text-sm" data-id="element-244">
                  Configuración fiscal completa y obtención del EIN
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 md:gap-4 pb-3 md:pb-4 border-b border-text-secondary/10" data-id="element-245">
              <span className="text-cta font-bold text-base md:text-lg flex-shrink-0" data-id="element-246">
                04
              </span>
              <div data-id="element-247">
                <h4 className="font-semibold mb-1 text-sm md:text-base" data-id="element-248">
                  Pilar 3: Dominar — Infraestructura y Crédito
                </h4>
                <p className="text-text-secondary text-xs md:text-sm" data-id="element-249">
                  Construcción de infraestructura financiera y bancaria
                  empresarial
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 md:gap-4" data-id="element-250">
              <span className="text-cta font-bold text-base md:text-lg flex-shrink-0" data-id="element-251">
                05
              </span>
              <div data-id="element-252">
                <h4 className="font-semibold mb-1 text-sm md:text-base" data-id="element-253">
                  Pilar 4: Cumplir — El Calendario del Dueño
                </h4>
                <p className="text-text-secondary text-xs md:text-sm" data-id="element-254">
                  Sistema de cumplimiento continuo y mantenimiento empresarial
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}